import routersManager from "@/managers/routers.manager";
import { defineComponent } from "vue";
import store from "@/store";
import { QuizType } from "../quiz/QuizComponent";

export default defineComponent({
    name: "RouteComponent",
    data() {
        return {
            name: (this.$route.params.name as string).replace(/_/g, ' '),
            route: null,
            directions: null,
            showQuiz: false,
            QuizType: QuizType
        };
    },
    async mounted() {
        this.route = await routersManager.getRoute(this.name);
        this.directions = this.extractSectionData(this.route?.directions );
    },
    methods: {
        goToMap(): void {
            if (!store.getters.routes?.find(r => r == this.name)) {
                this.showQuiz = true;
            } else {
                this.$router.push({ name: "map", params: { name: this.name.replace(/ /g, '_') } });
            }
            
        },
        hideQuiz(event: boolean): void {
            this.showQuiz = false;
            if (event) {
                store.commit("addRoute", this.name);
                this.$router.push({ name: "map", params: { name: this.name.replace(/ /g, '_') } });
            }
        },
        goBack(): void {
            this.$router.go(-1);
        },
        extractSectionData(text: string): any {
            const lines = text?.split('\n').map(line => line.trim()).filter(line => line.length > 0);
            const result = { init: { init: '' }, final: { final: '' } };
            let currentSection = null;
            let currentKey = null;

            lines?.forEach(line => {
                if (/^INICIO$/.test(line)) {
                    currentSection = 'init';
                    currentKey = 'init'; // Iniciar clave para la sección INICIO
                } else if (/^FINAL$/.test(line)) {
                    currentSection = 'final';
                    currentKey = 'final'; // Iniciar clave para la sección FINAL
                } else if (/^[A-Z]+$/.test(line)) {
                    // Si es una etiqueta (todas mayúsculas)
                    currentKey = line;
                    if (currentSection && currentKey) {
                        result[currentSection][currentKey.toLocaleLowerCase()] = ''; 
                        // Inicializar la clave en el objeto de la sección
                    }
                } else if (currentSection && currentKey) {
                    // Agregar el texto al valor de la clave actual en la sección actual
                    result[currentSection][currentKey.toLocaleLowerCase()] += 
                    (result[currentSection][currentKey] ? '\n' : '') + line;
                }
            });

            return result;
        }
    }
})